import React, {useState, useEffect} from 'react';
import {connect} from 'react-redux';
import _ from 'lodash';
import classnames from 'classnames/bind';
import {
  IOilFilter,
  IState,
  LocationType,
  Replacement,
} from '../../../../interface';
import {Dispatch} from 'redux';
import actions from '../../../../redux/actions';
import style from './index.module.scss';
import localesReplacement from '../../../../utils/localesReplacement';

const cx = classnames.bind(style);

interface IProps {
  filter: IOilFilter;
  replacements: Replacement;
  setLocationType: (value: string[]) => void;
  locationTypesList: LocationType[] | null;
}

interface Item {
  id: number;
  name: string;
  locationCategoryId: number;
  checked?: boolean;
}

//Workshop dropdown component with redux
export const WorkShopTypeDropdown = (props: IProps) => {
  const {filter, replacements, setLocationType, locationTypesList} = props;
  const [types, setTypes] = useState<Item[]>();
  useEffect(() => {
    setTypes(
      locationTypesList
        ? locationTypesList.map((item: LocationType) => ({
            id: item.id,
            name: item.name,
            value: item.name,
            locationCategoryId: item.locationCategory.id,
            checked: _.includes(filter.locationType, _.toString(item.id)),
          }))
        : [],
    );
  }, [locationTypesList]);
  //trigger the handle when selected the workshop
  const changeHandle = (event: React.ChangeEvent<HTMLInputElement>) => {
    const target = event.target;
    setTypes(
      _.chain(types)
        .map((type: Item) =>
          _.isEqual(type['name'], target.name)
            ? {...type, checked: target.checked}
            : type,
        )
        .value(),
    );
    target.checked
      ? setLocationType([
          ...(filter.locationType as string[]),
          (_.find(types, ['name', target.name]) as Item).id.toString(),
        ])
      : setLocationType(
          _.without(
            filter.locationType,
            (_.find(types, ['name', target.name]) as Item).id.toString(),
          ),
        );
  };
  return (
    <div className={`dropdown ${cx('dropdown')}`}>
      <div className='label'>
        {localesReplacement(replacements, 'Service Type')}
      </div>
      {/* flyout of dropdown */}
      <ul>
        {_.map(
          _.isEmpty(filter.locationCategories)
            ? types
            : _.filter(types, (type: Item) =>
                _.includes(
                  filter.locationCategories,
                  _.toString(type.locationCategoryId),
                ),
              ),
          (o, i) => (
            <li key={i}>
              <label className='custom-checkbox'>
                <input
                  type='checkbox'
                  name={o['name']}
                  checked={o['checked']}
                  onChange={changeHandle}
                />
                <span className='checkbox'></span>
                <i title={o['name']}>
                  {localesReplacement(replacements, o['name'])}
                </i>
              </label>
            </li>
          ),
        )}
      </ul>
    </div>
  );
};

const mapStateToProps = (state: IState) => ({
  replacements: state.replacements,
  filter: state.filter,
  locationTypesList: state.locationTypesList,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  setLocationType: (locationType: string[]) =>
    dispatch(actions.setLocationType(locationType)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(WorkShopTypeDropdown);
